/**
 * Keep in sync with server
 * `server/src/services/bannerSwap/bannerSwapTailIncomingEnd.ts`
 * (parity covered by bannerSwapOverlapClientParity tests).
 */
export const TAIL_INCOMING_END_LEAD_MS = 60_000;

export function computeTailIncomingPriorityEarlyEnd(params: {
  incomingStart: Date;
  peerStart: Date;
  peerEnd: Date;
}): Date | null {
  const incomingStartMs = params.incomingStart.getTime();
  const peerStartMs = params.peerStart.getTime();
  const peerEndMs = params.peerEnd.getTime();

  if (!(incomingStartMs < peerEndMs)) {
    return null;
  }

  const preferredMs = incomingStartMs - TAIL_INCOMING_END_LEAD_MS;
  const earliestAllowedMs = peerStartMs + 1;
  const latestAllowedMs = Math.min(incomingStartMs - 1, peerEndMs - 1);
  if (earliestAllowedMs > latestAllowedMs) {
    return new Date(incomingStartMs);
  }

  const earlyMs = Math.min(
    Math.max(preferredMs, earliestAllowedMs),
    latestAllowedMs
  );
  if (!(earlyMs < peerEndMs)) {
    return null;
  }
  return new Date(earlyMs);
}
